import { useEffect, useRef } from 'react';
import { HeroActions } from '../shared/HeroActions';
import { MediaFrame } from '../../components/MediaFrame';
import { ResponsiveImage } from '../../components/ResponsiveImage';

export function HeritageLedgerHero() {
  const media = useRef(null);

  useEffect(() => {
    const node = media.current;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!node || reduceMotion) return undefined;

    let frame = 0;
    const update = () => {
      frame = 0;
      const shift = Math.min(window.scrollY * 0.035, 16);
      node.style.setProperty('--hero-parallax', `${shift.toFixed(2)}px`);
    };
    const onScroll = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      node.style.removeProperty('--hero-parallax');
    };
  }, []);

  return (
    <section className="home-hero hero-ledger">
      <div className="hero-ledger__copy hero-copy-enter">
        <p className="hero-eyebrow">Hardscapes and masonry in Eastern NC</p>
        <h1>Built to look right. Planned to last.</h1>
        <p className="hero-lede">Pavers, patios, brick, block, tile, concrete, and faux stone for new installations and thoughtful repairs.</p>
        <HeroActions />
      </div>
      <figure ref={media} className="hero-ledger__media">
        <MediaFrame className="hero-ledger__image-frame">
          <picture>
            <source
              media="(max-width: 767px)"
              srcSet="/images/owner-projects/chimney-blue-sky-mobile-480.webp 480w, /images/owner-projects/chimney-blue-sky-mobile-640.webp 640w, /images/owner-projects/chimney-blue-sky-mobile.webp 768w"
              sizes="calc(100vw - 24px)"
            />
            <ResponsiveImage
              src="/images/owner-projects/chimney-blue-sky.webp"
              alt="Brick chimney completed by Vic’s Bricks against a blue Eastern North Carolina sky"
              width="768"
              height="960"
              fetchPriority="high"
              sizes="(max-width: 767px) calc(100vw - 24px), min(55vw, 730px)"
            />
          </picture>
        </MediaFrame>
        <figcaption>Chimney masonry from a Vic’s Bricks project in Eastern North Carolina.</figcaption>
      </figure>
    </section>
  );
}
